/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getParentBlockByType, getCurrentSat, getBandArray, getAnalyseBlock} from '../dataset';


// --------- band input blocks for charts -----------------------
// with input
Blockly.Blocks['input_scatter_y_band'] = {
    init: function () {
        var sat = 'l8';
        var dropdown = [];
        try {
            dropdown = this.getSatelliteBands(sat);
        } catch (e) {
            console.error(e);
        }
        this.appendValueInput('Band')
            .setCheck(['scatter_y_bands', 'scatter_math', 'graph_indices'])
            .appendField(new Blockly.FieldDropdown(dropdown), "band");
        this.setPreviousStatement(false, 'scatter_y_bands');
        this.setOutput(true, 'scatter_y_bands');
        this.setStyle('bandMath');
        this.prev_sat = 'l8';
        this.prevpar=this.getParent()
        this.setTooltip(Blockly.Msg.SCATTER_Y_BAND_INPUT_BLOCK_TOOLTIP);
        this.setOnChange(function () {
            if (this.getParent() && this.getParent().getParent()==null){this.prev_sat=null}
            sat = getCurrentSat(this);
            if ((sat !== null) && (sat !== '')) {
                var parent = this.getParent();
                if (getParentBlockByType(parent, "input_climate_data") !== null) {
                    var block = getParentBlockByType(parent, "input_climate_data");
                    sat = block.getFieldValue("param");
                }
                if (sat !== this.prev_sat ) {
                    var dropdown = [];
                    dropdown = this.getSatelliteBands(sat);
                    if (this.getParent()!==null && getAnalyseBlock(this.getParent())!==null && getAnalyseBlock(this.getParent()).type=='analyse_band_math'){dropdown=[['R','r_'], ['G','g_'],['B','b_']]}
                    let band = this.getInput("Band");
                    band.removeField("band", true)
                    band.appendField(new Blockly.FieldDropdown(dropdown), "band");
                    this.prev_sat = sat;
                    this.prepar= this.getParent()
                }
            }
        });
    },

    getSatelliteBands(sat) {
        let bands;

        if(!(sat in getBandArray)){
            var parent = this.getParent();
            let param;

            if (getParentBlockByType(parent, "input_climate_data") !== null) {
                let target_block = getParentBlockByType(parent, "input_climate_data");
                param = target_block.getFieldValue("param");
            } else if (getParentBlockByType(parent, "input_dem_data") !== null) {
                let target_block = getParentBlockByType(parent, "input_dem_data");
                param = target_block.getFieldValue("dropdown");
            } else {
                param = "NA"
            }
            bands = [[param, param]];
        } else {
            bands = getBandArray[sat]();
        } 

        return bands;
    },

    updateDropdowns_: function (sat) {
        var dropdown = [];
        dropdown = this.getSatelliteBands(sat);
        if (this.getParent()!==null && getAnalyseBlock(this.getParent())=='analyse_band_math'){dropdown=[['R','R'], ['G','G'],['B','B']]}
        let band = this.getInput("Band");
        band.removeField("band", true)
        band.appendField(new Blockly.FieldDropdown(dropdown), "band");
    }
}